import React, { useCallback, useEffect, useState } from 'react'
import {
    ButtonBack,
    ButtonFinish,
    ButtonNext,
    FooterLink,
    FormDiv,
    FullHeaderContainer,
    GridContainer,
    HeaderLinkCreate,
    StepperNav,
    Title,
} from './styles'
import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { Typography } from '@mui/material'
import Step1 from '../../components/LinkCreateStepper/Step1'
import Step2 from '../../components/LinkCreateStepper/Step2'
import Step3 from '../../components/LinkCreateStepper/Step3'
import { useForm, SubmitHandler } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import { useCommision } from '../../hooks/commission'
import { useContacts } from '../../hooks/contacts'
import {
    initialContact,
    InitialContactProtocol,
    Inputs,
    InputsFormStep1,
    InputsFormStep2,
    LinkData,
} from './interfaces'
import api from '../../services/axios'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import { get } from 'lodash'
import { useDispatch } from 'react-redux'
import { selectedMenu } from '../../store/modules/menu/actions'
import dayjs from '../../libs/dayjs'
import { OptInAlert } from '../../components/OptInAlert'
import { DocumentRequiredAlert } from '../../components/DocumentRequiredAlert'

const LinkCriar2: React.FC = () => {
    const { cnpj_cpf, verificationC, isDocumentValid } = useSelector(
        (state: StoreState) => state.auth.user
    )
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { getBillingCommission } = useCommision()
    const { saveContact, contacts } = useContacts()
    const [activeStep, setActiveStep] = React.useState(0)
    const [skipped, setSkipped] = React.useState(new Set<number>())
    const [linkData, setLinkData] = useState<LinkData>({} as LinkData)
    const [saveContactAsFavs, setSaveContactAsFavs] = useState(true)
    const [selectedFav, setSelectedFav] =
        useState<InitialContactProtocol>(initialContact)
    const [isLoading, setIsloading] = useState(false)

    // const [nomePagadorInput, setNomePagadorInput] = useState<NomePagadorInput>(NomePagadorInputInitial)
    const { handleSubmit } = useForm<Inputs>()
    const formStep1 = useForm<InputsFormStep1>()
    const formStep2 = useForm<InputsFormStep2>()
    // const formStep3 = useForm<Inputs>()

    const getPaymentDomicile = useCallback(async () => {
        try {
            const response = await api.get(
                `/institution/domicilio-pagamento/${cnpj_cpf}`
            )
            if (!response?.data?.id) {
                swal({
                    title: 'Opss!',
                    text: `Parece que você ainda não fez o cadastro dos seus dados bancários, clique aqui para cadastrar e começar a criar links!`,
                    icon: 'error',
                }).then(() => {
                    dispatch(
                        selectedMenu({
                            mainMenu: 'Minha conta',
                            subMenu: '',
                            currentLink: '/minhaconta',
                        })
                    )
                    navigate('/minhaconta/domicilio-pagamento')
                })
            }
        } catch (error) {}
    }, [cnpj_cpf, navigate, dispatch])

    useEffect(() => {
        getPaymentDomicile()
    }, [getPaymentDomicile])

    useEffect(() => {
        let dataPadrao = dayjs().add(5, 'd')

        if (dataPadrao.day() === 0) {
            dataPadrao = dataPadrao.add(1, 'd')
        }

        if (dataPadrao.day() === 6) {
            dataPadrao = dataPadrao.add(2, 'day')
        }
        formStep2.setValue('tipoLink', 0)
        formStep2.setValue('dataLiquidacao', dataPadrao.format('YYYY-MM-DD'))
        formStep2.setValue('quantParcelas', 1)
        formStep2.setValue('frequenciaCobranca', 1)
    }, [formStep2.setValue])

    useEffect(() => {
        if (selectedFav?.id === undefined) {
            formStep1.reset({
                nomeTitular: initialContact.nomeTitular,
                cnpjPagador: initialContact.cnpjPagador,
                email: initialContact.email,
                telefone: initialContact.telefone,
                valor: Number(formStep1.getValues('valor')),
            })
            return
        }
        // deselecionar a opcao salvar
        formStep1.reset({
            cnpjPagador: selectedFav?.cnpjPagador,
            nomeTitular: selectedFav?.nomeTitular,
            email: selectedFav?.email,
            telefone: selectedFav?.telefone,
            valor: Number(formStep1.getValues('valor')),
        })
    }, [selectedFav, formStep1.getValues, formStep1.reset])

    // function createTemporaryOptionContact(label: string) {
    //     return {
    //         label,
    //         value: {}
    //     }
    // }

    // function handleCreateTemporaryContact(inputValue: string) {
    //     const optionContact = createTemporaryOptionContact(inputValue)
    //     setContactsParsed(prev => [...prev, optionContact])
    // }

    if (!verificationC) {
        return <OptInAlert />
    }

    if (!isDocumentValid) {
        return <DocumentRequiredAlert />
    }
    const submitFormStep1: SubmitHandler<InputsFormStep1> = async (inputs) => {
        // alterar o link data
        const newLinkData: LinkData = { ...linkData }
        newLinkData.cnpjPagador = inputs.cnpjPagador.replace(/\D/g, '')
        newLinkData.nomeTitular = inputs.nomeTitular
        newLinkData.email = inputs.email
        newLinkData.telefone = inputs.telefone.replace(/\D/g, '')
        newLinkData.nomeLink = inputs.nomeLink
        newLinkData.valor = inputs.valor
        newLinkData.observacao = inputs.observacao
        setLinkData(newLinkData)
        // passar para o proximo step
        setActiveStep(1)
    }

    const submitFormStep2: SubmitHandler<InputsFormStep2> = async (inputs) => {
        const newLinkData: LinkData = { ...linkData }
        newLinkData.tipoLink = inputs.tipoLink
        newLinkData.dataLiquidacao = inputs.dataLiquidacao
        newLinkData.quantParcelas = inputs.quantParcelas
        newLinkData.frequenciaCobranca = inputs.frequenciaCobranca
        newLinkData.porcentagemSobreAgenda = inputs.porcentagemSobreAgenda
        newLinkData.dataLiquidacaoFinal = inputs.dataLiquidacaoFinal
        setLinkData(newLinkData)
        // alterar o link data
        // passar para o proximo step
        setActiveStep(2)
    }

    const submitFormStep3: SubmitHandler<Inputs> = async (inputs) => {
        try {
            setIsloading(true)
            if (saveContactAsFavs) {
                await saveContact({
                    cnpj_cpf,
                    numeroDocumentoTitular: linkData.cnpjPagador,
                    nomeTitular: linkData.nomeTitular,
                    email: linkData.email,
                    telefone: linkData.telefone,
                    contactId: selectedFav?.id || undefined,
                })
            }
            const { data } = await api.post(`/cobranca/criar`, {
                cnpj_cpf: cnpj_cpf,
                valor: Number(linkData.valor),
                cnpjPagador: linkData.cnpjPagador.replace(/\D/g, ''),
                nomePagador: linkData.nomeTitular,
                emailPagador: linkData.email,
                telefonePagador: linkData.telefone.replace(/\D/g, ''),
                dataLiquidacao: linkData.dataLiquidacao,
                quantParcelas: Number(linkData.quantParcelas),
                frequenciaCobranca: Number(linkData.frequenciaCobranca),
                observacao: linkData.observacao,
                tipoCobranca: Number(linkData.tipoLink),
                nomeCobranca: linkData.nomeLink,
                porcentagemSobreAgenda: linkData.porcentagemSobreAgenda,
                dataLiquidacaoFinal: linkData.dataLiquidacaoFinal,
            })
            swal({
                title: 'Cobrança criada com sucesso!',
                text: `Link da cobrança copiado para área de transferência`,
                icon: 'success',
            })

            // colocar no arquivo .env
            // const linkCobranca = `http://localhost:3000/${data.identificadorCobranca}`
            //   const linkCobranca = `https://treeweb.com.br/producao/${data.identificadorCobranca}`

            const linkCobranca = `${process.env.REACT_APP_BILLING_URL}/${data.identificadorCobranca}`
            navigator.clipboard.writeText(linkCobranca)
            setIsloading(false)
            navigate('/cobrancas?c=true')
        } catch (error) {
            const messageError = get(error, 'response.data.error', '')
            swal({
                title: 'Erro ao criar link de pagamento',
                text: `${messageError}`,
                icon: 'error',
            })
            setIsloading(false)
        }

        // alterar o link data
        // passar para o proximo step
    }

    // const submit: SubmitHandler<Inputs> = async (inputs) => {

    // }

    function renderActiveStep() {
        switch (activeStep) {
            case 0:
                return (
                    <Step1
                        saveContactAsFavs={saveContactAsFavs}
                        setSaveContactAsFavs={setSaveContactAsFavs}
                        submitFormStep1={submitFormStep1}
                        formStep1={formStep1}
                        contacts={contacts}
                        setSelectedFav={setSelectedFav}
                    />
                )
            case 1:
                return (
                    <Step2
                        linkData={linkData}
                        submitFormStep2={submitFormStep2}
                        formStep2={formStep2}
                    />
                )
            case 2:
                return (
                    <Step3
                        linkData={linkData}
                        getBillingCommission={getBillingCommission}
                        setActiveStep={setActiveStep}
                    />
                )
        }
    }

    const steps = ['Informações do cliente', 'Formas de pagamento', 'Resumo']

    const isStepOptional = (step: number) => {
        return step === 10
    }

    const isStepSkipped = (step: number) => {
        return skipped.has(step)
    }

    const handleNext = () => {
        let newSkipped = skipped
        if (activeStep === steps.length - 1) {
            return
        }
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values())
            newSkipped.delete(activeStep)
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const handleBack = () => {
        if (activeStep === 0) return
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    return (
        <GridContainer>
            <FullHeaderContainer>
                <HeaderLinkCreate>
                    <Title>Criar Cobrança</Title>
                </HeaderLinkCreate>

                <StepperNav>
                    {
                        <Box sx={{ width: '75%' }}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label, index) => {
                                    const stepProps: { completed?: boolean } =
                                        {}
                                    const labelProps: {
                                        optional?: React.ReactNode
                                    } = {}
                                    if (isStepOptional(index)) {
                                        labelProps.optional = (
                                            <Typography variant="caption">
                                                Optional
                                            </Typography>
                                        )
                                    }
                                    if (isStepSkipped(index)) {
                                        stepProps.completed = false
                                    }
                                    return (
                                        <Step key={label} {...stepProps}>
                                            <StepLabel {...labelProps}>
                                                {label}
                                            </StepLabel>
                                        </Step>
                                    )
                                })}
                            </Stepper>
                        </Box>
                    }
                </StepperNav>
            </FullHeaderContainer>

            <FormDiv
                onSubmit={handleSubmit(submitFormStep3)}
                id="billing-link-step-3"
            >
                {activeStep === steps.length ? (
                    <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            All steps completed - you&apos;re finished
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                pt: 2,
                            }}
                        >
                            <Box sx={{ flex: '1 1 auto' }} />
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>{renderActiveStep()}</React.Fragment>
                )}
            </FormDiv>
            <form
                className="sr-only"
                id="billing-link-step-1"
                onSubmit={formStep1.handleSubmit(submitFormStep1)}
            ></form>
            <form
                className="sr-only"
                id="billing-link-step-2"
                onSubmit={formStep2.handleSubmit(submitFormStep2)}
            ></form>

            <FooterLink>
                {activeStep === 0 ? (
                    <></>
                ) : (
                    <ButtonBack onClick={handleBack}>Voltar</ButtonBack>
                )}
                {activeStep === 0 && (
                    <ButtonNext type="submit" form="billing-link-step-1">
                        Avançar
                    </ButtonNext>
                )}
                {activeStep === 1 && (
                    <ButtonNext type="submit" form="billing-link-step-2">
                        Avançar
                    </ButtonNext>
                )}
                {activeStep === steps.length - 1 && (
                    <ButtonFinish
                        type="submit"
                        form="billing-link-step-3"
                        disabled={isLoading}
                    >
                        Finalizar
                    </ButtonFinish>
                )}
            </FooterLink>
        </GridContainer>
    )
}

export default LinkCriar2
